import { action, flow, makeObservable, observable } from "mobx";
import api from "../utils/apiService";
import { apiFetcher } from "../utils/fetch";

export default class Report {
  constructor() {
    this.items = [];

    makeObservable(this, {
      items: observable,
      fetch: flow,
      profitLoss: flow,
      profit: flow,
      deposit: flow,
      invoice: flow,
      occupant: flow,
      rentDuration: flow,
      averageTime: flow,
      ledger: flow,
      balance: flow,
      occupancy: flow,
      expense: flow,
      tenantRequest: flow,
      dueDate: flow,
      tenantVehicle: flow,
      setItems: action,
    });
  }

  setItems() {
    this.items = [];
  }

  *fetch(startDate, endDate, propertyId, page = 1, limit = 10) {
    try {
      const response = yield apiFetcher().get(
        `/report/transaction?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }
  *profitLoss(startDate, endDate, propertyId, page = 1, limit = 10) {
    try {
      const response = yield apiFetcher().get(
        `/report/profitLoss?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }

  *profit({ startDate, endDate, propertyId, page = 1, limit = 10 }) {
    try {
      const response = yield apiFetcher().get(
        `/report/profit?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }

  *deposit(startDate, endDate, propertyId, page = 1, limit = 10) {
    try {
      const response = yield apiFetcher().get(
        `/report/deposit?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }

  *invoice(startDate, endDate, propertyId, page = 1, limit = 10) {
    try {
      const response = yield apiFetcher().get(
        `/report/invoice?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }

  *occupant({ startDate, endDate, propertyId, frequency = "all", page = 1, limit = 10 }) {
    try {
      const response = yield apiFetcher().get(
        `/report/occupant?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&frequency=${frequency}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }

  *rentDuration({ startDate, endDate, propertyId, frequency = "all", page = 1, limit = 10 }) {
    try {
      const response = yield apiFetcher().get(
        `/report/rentDuration?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&frequency=${frequency}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }

  *averageTime({ startDate, endDate, propertyId, frequency = "all", page = 1, limit = 10 }) {
    try {
      const response = yield apiFetcher().get(
        `/report/averageTenatPaymentTime?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&frequency=${frequency}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }

  *ledger(startDate, endDate, propertyId, page = 1, limit = 10) {
    try {
      const response = yield apiFetcher().get(
        `/report/ledger?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }

  *balance(startDate, endDate, propertyId, page = 1, limit = 10) {
    try {
      const response = yield apiFetcher().get(
        `/report/balance?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }
  *occupancy(propertyId, page = 1, limit = 10) {
    try {
      const response = yield api.get(
        `/report/occupancy?propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }
  *expense(startDate, endDate, propertyId, page = 1, limit = 10) {
    try {
      const response = yield apiFetcher().get(
        `/report/expense?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }
  *tenantRequest(startDate, endDate, propertyId, page = 1, limit = 10) {
    try {
      const response = yield apiFetcher().get(
        `/report/tenantRequest?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }
  *dueDate({ startDate, endDate, propertyId, frequency = "all", page = 1, limit = 10 }) {
    try {
      const response = yield apiFetcher().get(
        `/report/dueDate?startDate=${startDate}&endDate=${endDate}&propertyId=${propertyId}&frequency=${frequency}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }
  *tenantVehicle(propertyId = "", page = 1, limit = 10) {
    try {
      const response = yield apiFetcher().get(
        `/report/tenantVehicle?propertyId=${propertyId}&page=${page}&limit=${limit}`
      );
      this.items = response.data;
      return { status: 200, data: response.data };
    } catch (error) {
      return { status: error?.response?.status, error: error?.response?.data };
    }
  }
}
